export default __webpack_public_path__ + "static/show5-74f51e10c63cdf3eb9373c0b482bdba1.png";